import {EmptySearchParamsFilterModel} from "./filters/empty-search-params-filter.model";

export class SearchParamsModel {
    public constructor(
        public pageNumber: number,
        public filter: EmptySearchParamsFilterModel
    ) {
    }
}
